import React, { useState } from 'react'

import { EnvelopeSimple, Phone } from '@phosphor-icons/react'
import { JoinUsNowModal } from 'Components/Blocks/Modals'
import { Button, Column, Text } from 'Components/UI'

import { CONTACT_EMAIL, CONTACT_PHONE } from 'Constants/ContactData'

import { StyledLink } from './styles'

function GetInTouch() {
  const [joinUsModalModalOpened, setJoinUsModalModalOpened] = useState(false)

  return (
    <Column
      alignItems={['center', 'center', 'center', 'center', 'flex-start']}
      gap={8}
    >
      <Text bold inverse screen20>
        Get In Touch
      </Text>

      <Button large onClick={() => setJoinUsModalModalOpened(true)}>
        Join Us Today
      </Button>

      <Column
        alignItems={['center', 'center', 'center', 'center', 'flex-start']}
        gap={4}
      >
        <StyledLink href={`tel: ${CONTACT_PHONE}`}>
          <Phone weight="fill" />

          <Text medium screen14 success>
            {CONTACT_PHONE}
          </Text>
        </StyledLink>

        <StyledLink href={`mailto: ${CONTACT_EMAIL}`}>
          <EnvelopeSimple weight="fill" />

          <Text medium screen14 success>
            {CONTACT_EMAIL}
          </Text>
        </StyledLink>
      </Column>

      <JoinUsNowModal
        isOpened={joinUsModalModalOpened}
        onClose={() => setJoinUsModalModalOpened(false)}
      />
    </Column>
  )
}

export default GetInTouch
